<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/3"
            :label="__('First name')"
          />
          <text-input
            v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/3"
            :label="__('Last name')"
          />
          <text-input
            v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3"
            :label="__('Email')"
          />
          <text-input
            v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Phone')"
          />
          <text-input
            v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('City')"
          />
          <text-input
            v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/3"
            :label="__('Address')"
          />
          <select-input
            v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Country')"
          >
            <option :value="null" />
            <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>
          <select-input
            v-model="form.campus" :error="form.errors.campus" class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Campus')"
          >
            <option value="karachi">Karachi</option>
            <option value="Islamabad">Islamabad</option>
            <option value="online">Ice Global</option>
            />
          </select-input>
          <select-input
            v-model="form.class_id" :error="form.errors.class_id" class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Class')"
          >
            <option :value="null">{{ __('Select Class') }}</option>
            <option v-for="c in classes" :key="c.id" :value="c.id">{{ c.name }}</option>
          </select-input>
          <select-input
            v-model="form.student_category_id" :error="form.errors.student_category_id" class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Category')"
          >
            <option :value="null">{{ __('Select Category') }}</option>
            <option v-for="cat in studentCategories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
          </select-input>
          <!-- <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3" type="password" autocomplete="new-password" :label="__('Password')" /> -->
          <div class="password-input-container w-full lg:w-1/3">
            <text-input
              v-model="form.password" :type="passwordFieldType" :error="form.errors.password"
              label="Password"
            />
            <i
              :class="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" class="toggle-password-icon"
              @click="togglePasswordVisibility"
            />
          </div>
          <file-input
            v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file"
            accept="image/*" :label="__('Photo')"
          />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('create')
            }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    classes: Array,
    studentCategories: Array,
    title: String,
  },
  remember: 'form',
  data() {
    return {
      showPassword: false,
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        city: null,
        address: '',
        country_id: null,
        campus: '',
        class_id: null,
        student_category_id: null,
        password: '',
        role_id: null,
        photo: null,
      }),
    }
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password'
    },
  },
  created() {
    // this.setDefaultValue(this.countries, 'country_id', 'United States')
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    setDefaultValue(arr, key, value) {
      const find = arr.find(i => i.name.match(new RegExp(value + '.*')))
      if (find) {
        this.form[key] = find['id']
      }
    },
    store() {
      this.form.post(this.route('customers.store'))
    },
  },
}
</script>
<style>
.password-input-container {
  margin-right: 10px;
  position: relative;
  /* display: flex; */
  /* align-items: center; */
}

.toggle-password-icon {
  position: absolute;
  right: 10px;
  top: 38%;
  cursor: pointer;
}
</style>
